<div class="hero-section-container" [appStoryblok]="_editable">
  <div class="section dark intro-section">
    @for (blok of content; track blok._uid) {
      <ndc-dynamic
        [ndcDynamicComponent]="$any(components[blok.component])"
        [ndcDynamicInputs]="$any(blok)"
      ></ndc-dynamic>
    }
    <div class="page hero-image headless">
      <div class="hero-image-inner">
        <div class="video-container">
          <video
            #videoEl
            loop
            muted
            playsinline
            disablepictureinpicture="true"
            [attr.width]="width || 1620"
            [attr.height]="height || 1080"
            [poster]="poster?.filename || videoPoster | storyblokCdn"
          ></video>
        </div>
      </div>
    </div>
  </div>
  <div class="section dark black">
    <div class="page hero-image-spacer">
      <div class="hero-image-spacer-inner"></div>
    </div>
  </div>
</div>
